export enum AssetStatus {
  Used = 0,
  OutOfService = 1,
  OnService = 2,
}
